import React, { FunctionComponent } from 'react';
import analytics from 'scenes/motor/analytics';

import { PromoCodeStep as CommonPromoCodeStep } from 'scenes/common/components/Steps';
import { getPromoCode, hasQuoteNumber } from 'scenes/motor/selectors';
import { MotorFullPageProps } from 'scenes/motor/types';
import { getApiData } from 'scenes/common/helpers/apiData';

const PromoCodeStep: FunctionComponent<MotorFullPageProps> = ({
  funnelState,
  onCreateQuote,
  onUpdatePromoCode,
  onUpdateQuoteDetails,
  referenceData,
}) => (
  <CommonPromoCodeStep
    quoteDetails={funnelState.apiResponses.quoteDetails}
    onUpdatePromoCode={onUpdatePromoCode}
    onCreateQuote={onCreateQuote}
    onUpdateQuoteDetails={onUpdateQuoteDetails}
    hasQuoteNumber={hasQuoteNumber(funnelState)}
    defaultPromoCodeStateValue={getPromoCode(funnelState)}
    onSubmitQuoteAnalytics={() =>
      analytics().submitQuote(funnelState, getApiData(referenceData))
    }
  />
);

export default PromoCodeStep;
